import React, { useState, useEffect } from "react";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [regUsername, setRegUsername] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regPassword2, setRegPassword2] = useState("");
  const [regShowPassword, setRegShowPassword] = useState(false);
  const [regShowPassword2, setRegShowPassword2] = useState(false);
  const [regError, setRegError] = useState("");
  const [regSuccess, setRegSuccess] = useState("");
  const [admin, setAdmin] = useState(false);
  const [zamestnanci, setZamestnanci] = useState([]);
  const [error, setError] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [saveSuccess, setSaveSuccess] = useState("");
  // Admin management
  const [adminsPanel, setAdminsPanel] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [newAdminUser, setNewAdminUser] = useState("");
  const [newAdminEmail, setNewAdminEmail] = useState("");
  const [newAdminPass, setNewAdminPass] = useState("");
  const [newAdminPass2, setNewAdminPass2] = useState("");
  const [newAdminShow1, setNewAdminShow1] = useState(false);
  const [newAdminShow2, setNewAdminShow2] = useState(false);
  const [adminsMsg, setAdminsMsg] = useState("");
  const [adminsErr, setAdminsErr] = useState("");

  // Slovak labels for all fields
  const fieldLabels = {
    pin: "PIN",
    email: "E-mail",
    titleBefore: "Titul pred menom",
    firstName: "Krstné meno",
    lastName: "Priezvisko",
    titleAfter: "Titul za menom",
    birth_lastname: "Rodné priezvisko",
    birthDate: "Dátum narodenia",
    rodne_cislo: "Rodné číslo",
    birth_place: "Miesto narodenia",
    nationality: "Národnosť",
    state_citizenship: "Štátna príslušnosť",
    state_citizenship_other: "Iná štátna príslušnosť",
    id_card: "Číslo občianskeho preukazu",
    street_name: "Ulica",
    cislo_domu: "Číslo domu",
    city: "Mesto",
    zip: "PSČ",
    marital_status: "Rodinný stav",
    phone: "Telefón",
    insurance: "Zdravotná poisťovňa",
    insurance_other: "Iná poisťovňa",
    bank_name: "Banka",
    bank_iban: "IBAN",
    is_student: "Som študent",
    is_pensioner: "Som poberateľom dôchodku",
    is_invalid_pensioner: "Som poberateľom invalidného dôchodku",
    is_registered_unemployment: "Som evidovaný na úrade práce",
    position: "Dohodnutá pracovná pozícia",
    osobne_cislo: "Osobné číslo zamestnanca",
    has_trial_period: "Skúšobná doba",
    trial_period_months: "Dĺžka skúšobnej doby (mesiace)",
    previous_employer: "Predchádzajúci zamestnávateľ",
    work_permit: "Pracovné povolenie / vízum",
    company: "Spoločnosť",
    declaration_truth: "Vyhlásenie o pravdivosti",
    contractType: "Typ pracovného pomeru",
    part_time_hours_per_day: "Skrátený úväzok (hod./deň)",
    startDate: "Možný dátum nástupu",
    dohodnuty_uvazok: "Dohodnutý úväzok (hod./týždeň)",
    wage_type: "Typ mzdy",
    wage_brutto: "Mzda brutto (€)",
    contract_duration_type: "Doba trvania zmluvy",
    tax_vyhlasenie: "Úľava na dani",
    children_count: "Počet detí",
    tax_bonus: "Daňový bonus",
    has_health_issues: "Zdravotné obmedzenia",
    health_notes: "Popis zdravotných obmedzení",
    consent_gdpr: "Súhlas GDPR",
    notes: "Poznámky",
    filled_by: "Vyplnil",
    filled_on: "Dátum vyplnenia"
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setAdmin(false);
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "login", username, password })
      });
      if (!res.ok) throw new Error("Nesprávne prihlasovacie údaje");
      const data = await res.json();
      if (data.success) {
        loadEmployees();
        setAdmin(true);
      } else {
        throw new Error(data.error || "Chyba prihlásenia");
      }
    } catch (e) {
      setError(e.message || "Chyba prihlásenia");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegError("");
    setRegSuccess("");
    // basic client validation
    if (!regUsername || !regPassword) {
      setRegError("Používateľské meno a heslo sú povinné");
      return;
    }
    if (regPassword !== regPassword2) {
      setRegError("Heslá sa nezhodujú");
      return;
    }
    if (regPassword.length < 8 || !/[A-Z]/.test(regPassword) || !/[a-z]/.test(regPassword) || !/\d/.test(regPassword)) {
      setRegError("Heslo musí mať aspoň 8 znakov a obsahovať veľké písmeno, malé písmeno a číslo");
      return;
    }
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "register_admin", username: regUsername, password: regPassword, email: regEmail || undefined })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        throw new Error((data && data.error) || "Registrácia zlyhala");
      }
      setRegSuccess("Admin účet vytvorený. Môžete sa prihlásiť.");
      // prepnúť späť na login po chvíli
      setTimeout(() => {
        setShowRegister(false);
        setUsername(regUsername);
        setRegUsername("");
        setRegEmail("");
        setRegPassword("");
        setRegPassword2("");
      }, 1200);
    } catch (err) {
      setRegError(err.message || "Registrácia zlyhala");
    }
  };

  const loadEmployees = async () => {
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "list_employees" })
      });
      if (!res.ok) throw new Error("Chyba načítania zamestnancov");
      const data = await res.json();
      setZamestnanci(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message);
    }
  };

  const loadAdmins = async () => {
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "list_admins" })
      });
      if (!res.ok) throw new Error("Chyba načítania adminov");
      const data = await res.json();
      setAdmins(Array.isArray(data) ? data : []);
    } catch (e) {
      setAdmins([]);
    }
  };

  useEffect(() => {
    if (admin && adminsPanel) loadAdmins();
  }, [admin, adminsPanel]);

  const createAdmin = async (e) => {
    e.preventDefault();
    setAdminsErr("");
    setAdminsMsg("");
    if (!newAdminUser || !newAdminPass) {
      setAdminsErr("Používateľské meno a heslo sú povinné");
      return;
    }
    if (newAdminPass !== newAdminPass2) {
      setAdminsErr("Heslá sa nezhodujú");
      return;
    }
    if (newAdminPass.length < 8 || !/[A-Z]/.test(newAdminPass) || !/[a-z]/.test(newAdminPass) || !/\d/.test(newAdminPass)) {
      setAdminsErr("Heslo musí mať aspoň 8 znakov a obsahovať veľké písmeno, malé písmeno a číslo");
      return;
    }
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "create_admin", username: newAdminUser, password: newAdminPass, email: newAdminEmail || undefined })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) throw new Error((data && data.error) || "Vytvorenie admina zlyhalo");
      setAdminsMsg("Admin vytvorený");
      setNewAdminUser(""); setNewAdminEmail(""); setNewAdminPass(""); setNewAdminPass2("");
      loadAdmins();
    } catch (err) {
      setAdminsErr(err.message || "Vytvorenie admina zlyhalo");
    }
  };

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);
    setFormData({ ...employee });
    setEditMode(false);
    setSaveSuccess("");
  };

  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSaveChanges = async () => {
    setSaveSuccess("");
    setError("");
    try {
      const res = await fetch("/php/admin_portal.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "update_employee",
          pin: selectedEmployee.pin,
          data: formData
        })
      });
      if (!res.ok) throw new Error("Chyba uloženia");
      const result = await res.json();
      if (result.success) {
        setSaveSuccess("Zmeny úspešne uložené!");
        setEditMode(false);
        loadEmployees();
        // Update selected employee with new data
        setSelectedEmployee({ ...formData });
      } else {
        throw new Error(result.error || "Chyba uloženia");
      }
    } catch (e) {
      setError(e.message);
    }
  };

  const handleFileUpload = async (field, file) => {
    if (!file) return;
    setError("");
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("pin", selectedEmployee.pin);
    formDataUpload.append("field", field);

    try {
      const res = await fetch("/php/upload_document.php", {
        method: "POST",
        body: formDataUpload
      });
      if (!res.ok) throw new Error("Chyba nahrávania dokumentu");
      const result = await res.json();
      if (result.success) {
        setSaveSuccess(`Dokument pre pole "${fieldLabels[field]}" úspešne nahraný!`);
      } else {
        throw new Error(result.error || "Chyba nahrávania");
      }
    } catch (e) {
      setError(e.message);
    }
  };

  if (!admin) {
    return (
      <div style={{ maxWidth: 400, margin: "2rem auto", background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 2px 16px #0001" }}>
        <h2>{showRegister ? "Registrácia admina" : "Admin prihlásenie"}</h2>
        {!showRegister ? (
        <form onSubmit={handleLogin}>
            <div style={{ marginBottom: 12 }}>
              <label>Používateľské meno:</label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                style={{ width: "100%", padding: "8px", marginTop: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label>Heslo:</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  style={{ width: "100%", padding: "8px", marginTop: 4, paddingRight: 40 }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: 18,
                    padding: 4
                  }}
                  title={showPassword ? "Skryť heslo" : "Zobraziť heslo"}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>
            <button type="submit" style={{ width: "100%", padding: 10 }}>Prihlásiť sa</button>
          </form>
        ) : (
          <form onSubmit={handleRegister}>
            <div style={{ marginBottom: 12 }}>
              <label>Používateľské meno:</label>
              <input
                type="text"
                value={regUsername}
                onChange={e => setRegUsername(e.target.value)}
                required
                style={{ width: "100%", padding: "8px", marginTop: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label>E-mail (voliteľné):</label>
              <input
                type="email"
                value={regEmail}
                onChange={e => setRegEmail(e.target.value)}
                style={{ width: "100%", padding: "8px", marginTop: 4 }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label>Heslo:</label>
              <div style={{ position: "relative" }}>
                <input
                  type={regShowPassword ? "text" : "password"}
                  value={regPassword}
                  onChange={e => setRegPassword(e.target.value)}
                  required
                  style={{ width: "100%", padding: "8px", marginTop: 4, paddingRight: 40 }}
                />
                <button type="button" onClick={() => setRegShowPassword(!regShowPassword)}
                  style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer", fontSize: 18, padding: 4 }}
                  title={regShowPassword ? "Skryť heslo" : "Zobraziť heslo"}
                >{regShowPassword ? "👁️" : "👁️‍🗨️"}</button>
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label>Potvrdenie hesla:</label>
              <div style={{ position: "relative" }}>
                <input
                  type={regShowPassword2 ? "text" : "password"}
                  value={regPassword2}
                  onChange={e => setRegPassword2(e.target.value)}
                  required
                  style={{ width: "100%", padding: "8px", marginTop: 4, paddingRight: 40 }}
                />
                <button type="button" onClick={() => setRegShowPassword2(!regShowPassword2)}
                  style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer", fontSize: 18, padding: 4 }}
                  title={regShowPassword2 ? "Skryť heslo" : "Zobraziť heslo"}
                >{regShowPassword2 ? "👁️" : "👁️‍🗨️"}</button>
              </div>
            </div>
            <button type="submit" style={{ width: "100%", padding: 10 }}>Vytvoriť admin účet</button>
        </form>
        )}
        {!showRegister ? (
          <div style={{ marginTop: 12, fontSize: 14 }}>
            Nemáte účet? {" "}
            <button type="button" onClick={() => { setShowRegister(true); setRegError(""); setRegSuccess(""); }} style={{ background: "none", border: "none", color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}>Zaregistrovať admina</button>
          </div>
        ) : (
          <div style={{ marginTop: 12, fontSize: 14 }}>
            Už máte účet? {" "}
            <button type="button" onClick={() => setShowRegister(false)} style={{ background: "none", border: "none", color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}>Prejsť na prihlásenie</button>
          </div>
        )}
        {(!showRegister && error) && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
        {(showRegister && regError) && <div style={{ color: 'red', marginTop: 12 }}>{regError}</div>}
        {(showRegister && regSuccess) && <div style={{ color: 'green', marginTop: 12 }}>{regSuccess}</div>}

        {!showRegister && (
          <div style={{ marginTop: 16 }}>
            <button
              type="button"
              onClick={() => window.open('/php/fix_admin_password.php', '_blank', 'noopener,noreferrer')}
              style={{ padding: '8px 12px', background: '#f5f5f5', border: '1px solid #ccc', borderRadius: 6, cursor: 'pointer' }}
            >
              Resetovať heslo (admin)
            </button>
            <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>
              Otvorí nástroj na reset hesla. Po použití súbor odstráňte zo servera.
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1200, margin: "2rem auto", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 2px 16px #0001", marginBottom: 20 }}>
        <h2>Admin rozhranie – Zoznam zamestnancov</h2>
        <button onClick={loadEmployees} style={{ marginBottom: 16 }}>Obnoviť zoznam</button>
        <button onClick={() => setAdminsPanel(!adminsPanel)} style={{ marginLeft: 8, marginBottom: 16 }}>
          {adminsPanel ? "Skryť správu adminov" : "Správa adminov"}
        </button>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        {saveSuccess && <div style={{ color: 'green', marginBottom: 12 }}>{saveSuccess}</div>}

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 24 }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>PIN</th>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>Meno</th>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>Priezvisko</th>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>Email</th>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>Osobné číslo</th>
              <th style={{ padding: 8, border: "1px solid #ddd" }}>Akcia</th>
            </tr>
          </thead>
          <tbody>
            {zamestnanci.map(z => (
              <tr key={z.pin} style={{ background: selectedEmployee?.pin === z.pin ? "#e3f2fd" : "transparent" }}>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>{z.pin}</td>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>{z.firstName}</td>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>{z.lastName}</td>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>{z.email}</td>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>{z.osobne_cislo || "-"}</td>
                <td style={{ padding: 8, border: "1px solid #ddd" }}>
                  <button onClick={() => handleSelectEmployee(z)}>Detail / Upraviť</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {adminsPanel && (
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 2px 16px #0001", marginBottom: 20 }}>
          <h3>Správa administrátorov</h3>
          <div style={{ marginBottom: 16 }}>
            <h4>Aktívni administrátori</h4>
            {admins.length === 0 ? (
              <div>Žiadni administrátori</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f7f7f7" }}>
                    <th style={{ padding: 8, border: '1px solid #ddd' }}>ID</th>
                    <th style={{ padding: 8, border: '1px solid #ddd' }}>Používateľ</th>
                    <th style={{ padding: 8, border: '1px solid #ddd' }}>Email</th>
                    <th style={{ padding: 8, border: '1px solid #ddd' }}>Vytvorený</th>
                    <th style={{ padding: 8, border: '1px solid #ddd' }}>Posledné prihlásenie</th>
                  </tr>
                </thead>
                <tbody>
                  {admins.map(a => (
                    <tr key={a.id}>
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>{a.id}</td>
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>{a.username}</td>
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>{a.email || '-'}</td>
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>{a.created_at}</td>
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>{a.last_login || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div style={{ marginTop: 16 }}>
            <h4>Pridať nového admina</h4>
            <form onSubmit={createAdmin}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label>Používateľské meno:</label>
                  <input type="text" value={newAdminUser} onChange={e => setNewAdminUser(e.target.value)} required style={{ width: '100%', padding: 8 }} />
                </div>
                <div>
                  <label>E-mail (voliteľné):</label>
                  <input type="email" value={newAdminEmail} onChange={e => setNewAdminEmail(e.target.value)} style={{ width: '100%', padding: 8 }} />
                </div>
                <div>
                  <label>Heslo:</label>
                  <div style={{ position: 'relative' }}>
                    <input type={newAdminShow1 ? 'text' : 'password'} value={newAdminPass} onChange={e => setNewAdminPass(e.target.value)} required style={{ width: '100%', padding: 8, paddingRight: 40 }} />
                    <button type="button" onClick={() => setNewAdminShow1(!newAdminShow1)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer' }}>{newAdminShow1 ? '👁️' : '👁️‍🗨️'}</button>
                  </div>
                </div>
                <div>
                  <label>Potvrdenie hesla:</label>
                  <div style={{ position: 'relative' }}>
                    <input type={newAdminShow2 ? 'text' : 'password'} value={newAdminPass2} onChange={e => setNewAdminPass2(e.target.value)} required style={{ width: '100%', padding: 8, paddingRight: 40 }} />
                    <button type="button" onClick={() => setNewAdminShow2(!newAdminShow2)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer' }}>{newAdminShow2 ? '👁️' : '👁️‍🗨️'}</button>
                  </div>
                </div>
              </div>
              <button type="submit" style={{ marginTop: 12, padding: '8px 16px' }}>Pridať admina</button>
            </form>
            {adminsErr && <div style={{ color: 'red', marginTop: 8 }}>{adminsErr}</div>}
            {adminsMsg && <div style={{ color: 'green', marginTop: 8 }}>{adminsMsg}</div>}
          </div>

          <hr style={{ margin: '20px 0' }} />
          <div>
            <h4>Reset hesla administrátora</h4>
            <p style={{ marginTop: 0, color: '#666' }}>
              Ak sa nevieš prihlásiť alebo si potrebuješ dočasne nastaviť známe heslo, otvor nástroj na reset.
              Po úspešnom resete tento súbor zo servera odstráňte.
            </p>
            <button
              type="button"
              onClick={() => window.open('/php/fix_admin_password.php', '_blank', 'noopener,noreferrer')}
              style={{ padding: '8px 12px', background: '#f5f5f5', border: '1px solid #ccc', borderRadius: 6, cursor: 'pointer' }}
            >
              Otvoriť nástroj na reset hesla
            </button>
          </div>
        </div>
      )}
      {selectedEmployee && (
        <div style={{ background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 2px 16px #0001" }}>
          <h3>Detail zamestnanca: {selectedEmployee.firstName} {selectedEmployee.lastName}</h3>
          <div style={{ marginBottom: 16 }}>
            <button
              onClick={() => setEditMode(!editMode)}
              style={{ marginRight: 8, padding: "8px 16px" }}
            >
              {editMode ? "Zrušiť úpravu" : "Upraviť údaje"}
            </button>
            {editMode && (
              <button
                onClick={handleSaveChanges}
                style={{ padding: "8px 16px", background: "#4CAF50", color: "white", border: "none", borderRadius: 4 }}
              >
                Uložiť zmeny
              </button>
            )}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            {Object.keys(fieldLabels).map(field => {
              const value = formData[field];
              const label = fieldLabels[field];

              // Skip internal fields
              if (field === "filled_by" || field === "filled_on") return null;

              return (
                <div key={field} style={{ marginBottom: 12, padding: 12, border: "1px solid #e0e0e0", borderRadius: 8 }}>
                  <label style={{ fontWeight: "bold", display: "block", marginBottom: 4 }}>
                    {label}:
                  </label>
                  {editMode ? (
                    <>
                      {/* Boolean fields */}
                      {["is_student", "is_pensioner", "is_invalid_pensioner", "is_registered_unemployment", "has_trial_period", "declaration_truth", "consent_gdpr", "tax_vyhlasenie", "tax_bonus"].includes(field) ? (
                        <select
                          value={value === 1 || value === "1" || value === true ? "1" : "0"}
                          onChange={(e) => handleFieldChange(field, e.target.value)}
                          style={{ width: "100%", padding: 6 }}
                        >
                          <option value="0">Nie</option>
                          <option value="1">Áno</option>
                        </select>
                      ) : field === "has_health_issues" ? (
                        <select
                          value={value || "no"}
                          onChange={(e) => handleFieldChange(field, e.target.value)}
                          style={{ width: "100%", padding: 6 }}
                        >
                          <option value="no">Nie</option>
                          <option value="yes">Áno</option>
                        </select>
                      ) : field === "notes" || field === "health_notes" || field === "previous_employer" ? (
                        <textarea
                          value={value || ""}
                          onChange={(e) => handleFieldChange(field, e.target.value)}
                          rows={3}
                          style={{ width: "100%", padding: 6 }}
                        />
                      ) : field === "birthDate" || field === "startDate" ? (
                        <input
                          type="date"
                          value={value || ""}
                          onChange={(e) => handleFieldChange(field, e.target.value)}
                          style={{ width: "100%", padding: 6 }}
                        />
                      ) : (
                        <input
                          type="text"
                          value={value || ""}
                          onChange={(e) => handleFieldChange(field, e.target.value)}
                          style={{ width: "100%", padding: 6 }}
                        />
                      )}
                    </>
                  ) : (
                    <div style={{ padding: 6, background: "#f9f9f9", borderRadius: 4 }}>
                      {["is_student", "is_pensioner", "is_invalid_pensioner", "is_registered_unemployment", "has_trial_period", "declaration_truth", "consent_gdpr", "tax_vyhlasenie", "tax_bonus"].includes(field)
                        ? (value === 1 || value === "1" || value === true ? "Áno" : "Nie")
                        : field === "has_health_issues"
                          ? (value === "yes" ? "Áno" : "Nie")
                          : (value || "-")
                      }
                    </div>
                  )}

                  {/* File upload */}
                  <div style={{ marginTop: 8 }}>
                    <label style={{ fontSize: 12, color: "#666", display: "block", marginBottom: 4 }}>
                      Nahrať dokument pre toto pole:
                    </label>
                    <input
                      type="file"
                      onChange={(e) => handleFileUpload(field, e.target.files[0])}
                      style={{ fontSize: 12 }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
